import {
  ON,
  OFF,
  PAL_RECURRING_OFF_ON,
  PAL_SINGLE_PAYMENT_FEE_OFF_ON,
  PAY_A_LOAN_OFF_ON,
} from 'consts';
import buildExtDdaRtConfig from '../Util/buildExtDdaRtConfig';

export const FSP_PAL_LIST_OFF_ON = 'palListOffOn';

const LABELS = {
  PRINCIPAL: 'Principal',
  INTEREST: 'Interest',
  ESCROW: 'Escrow',
};

export const Fields = {
  GENERAL_PAL_OFF_ON: { label: 'Enabled', name: PAY_A_LOAN_OFF_ON },
  GENERAL_PAL_RECURRING_FEE_OFF_ON: {
    label: 'Recurring Fee',
    name: PAL_RECURRING_OFF_ON,
  },
  GENERAL_PAL_SINGLE_PAYMENT_FEE_OFF_ON: {
    label: 'Single Payment Fee',
    name: PAL_SINGLE_PAYMENT_FEE_OFF_ON,
  },
  GENERAL_DEBIT_CARD_OFF_ON: {
    name: `debitCardOffOn`,
    label: 'Debit Card',
  },
  GENERAL_EXTERNAL_DDA_OFF_ON: {
    name: 'externalDdaOffOn',
    label: 'External Account',
  },
  GENERAL_TERMS_OF_SERVICE_OFF_ON: {
    name: 'termsAndConditionsOffOn',
    label: 'Require Terms of Service',
  },
  GENERAL_TERMS_AND_CONDITIONS_URL: {
    name: 'termsAndConditionsUrl',
    label: 'Terms of Service URL',
  },
  GENERAL_ALLOW_DEFAULT_FUNDING_OFF_ON: {
    name: 'palDefaultOffOn',
    label: 'Allow Default Funding Method',
  },
  PAYMENT_PROCESSING_PURPOSE_OFF_ON: {
    name: 'paymentPurposeOffOn',
    label: 'Payment With a Purpose',
  },
  GENERAL_PAYMENT_PURPOSE_CORE_OFF_ON: {
    name: 'paymentPurposeCoreOffOn',
    label: 'Payment Purpose Core',
  },
  PAYMENT_PROCESSING_MORTGAGE_PRINCIPAL_OFF_ON: {
    name: 'paymentPurposeConfig.mortgagePaymentTypes.principalOffOn',
    label: LABELS.PRINCIPAL,
  },
  PAYMENT_PROCESSING_MORTGAGE_INTEREST_OFF_ON: {
    name: 'paymentPurposeConfig.mortgagePaymentTypes.interestOffOn',
    label: LABELS.INTEREST,
  },
  PAYMENT_PROCESSING_MORTGAGE_ESCROW_OFF_ON: {
    name: 'paymentPurposeConfig.mortgagePaymentTypes.escrowOffOn',
    label: LABELS.ESCROW,
  },
  PAYMENT_PROCESSING_HELOC_PRINCIPAL_OFF_ON: {
    name: 'paymentPurposeConfig.helocPaymentTypes.principalOffOn',
    label: LABELS.PRINCIPAL,
  },
  PAYMENT_PROCESSING_HELOC_INTEREST_OFF_ON: {
    name: 'paymentPurposeConfig.helocPaymentTypes.interestOffOn',
    label: LABELS.INTEREST,
  },
  PAYMENT_PROCESSING_HELOC_ESCROW_OFF_ON: {
    name: 'paymentPurposeConfig.helocPaymentTypes.escrowOffOn',
    label: LABELS.ESCROW,
  },
  PAYMENT_PROCESSING_STUDENT_PRINCIPAL_OFF_ON: {
    name: 'paymentPurposeConfig.studentPaymentTypes.principalOffOn',
    label: LABELS.PRINCIPAL,
  },
  PAYMENT_PROCESSING_STUDENT_INTEREST_OFF_ON: {
    name: 'paymentPurposeConfig.studentPaymentTypes.interestOffOn',
    label: LABELS.INTEREST,
  },
  PAYMENT_PROCESSING_PERSONAL_PRINCIPAL_OFF_ON: {
    name: 'paymentPurposeConfig.personalPaymentTypes.principalOffOn',
    label: LABELS.PRINCIPAL,
  },
  PAYMENT_PROCESSING_PERSONAL_INTEREST_OFF_ON: {
    name: 'paymentPurposeConfig.personalPaymentTypes.interestOffOn',
    label: LABELS.INTEREST,
  },
  PAYMENT_PROCESSING_AUTO_PRINCIPAL_OFF_ON: {
    name: 'paymentPurposeConfig.autoPaymentTypes.principalOffOn',
    label: LABELS.PRINCIPAL,
  },
  PAYMENT_PROCESSING_AUTO_INTEREST_OFF_ON: {
    name: 'paymentPurposeConfig.autoPaymentTypes.interestOffOn',
    label: LABELS.INTEREST,
  },
  PAYMENT_PROCESSING_OTHER_PRINCIPAL_OFF_ON: {
    name: 'paymentPurposeConfig.otherPaymentTypes.principalOffOn',
    label: LABELS.PRINCIPAL,
  },
  PAYMENT_PROCESSING_OTHER_INTEREST_OFF_ON: {
    name: 'paymentPurposeConfig.otherPaymentTypes.interestOffOn',
    label: LABELS.INTEREST,
  },
  PAYMENT_PROCESSING_CREDIT_CARD_PRINCIPAL_OFF_ON: {
    name: 'paymentPurposeConfig.creditCardPaymentTypes.principalOffOn',
    label: LABELS.PRINCIPAL,
  },
  PAYMENT_PROCESSING_CREDIT_CARD_INTEREST_OFF_ON: {
    name: 'paymentPurposeConfig.creditCardPaymentTypes.interestOffOn',
    label: LABELS.INTEREST,
  },
  GENERAL_MAX_AUTH_QUESTIONS: {
    name: 'maxAuthQuestion',
    label: 'Max Authorization Question',
  },
  GENERAL_MIN_AUTH_QUESTIONS: {
    name: 'minAuthQuestion',
    label: 'Min Authorization Question',
  },
  GENERAL_STATEMENT_IMPORT_FROM: {
    name: 'statementImportFrom',
    label: 'Statement Import From',
  },
  EXT_DDA_RT_OFF_ON: {
    name: 'extDdaRtConfig.featureEnabled',
    label: 'Processing',
  },
  EXT_DDA_RT_DELAY_DAYS: {
    name: 'extDdaRtConfig.delayDays',
    label: 'Delivery Timeframe',
  },
};

export const getValuesForApi = (values) => ({
  palOffOn: values?.[Fields.GENERAL_PAL_OFF_ON.name],
});

export const getValuesForConfigPalApi = (values) => {
  return {
    termsAndConditionsUrl:
      values?.[Fields.GENERAL_TERMS_AND_CONDITIONS_URL.name],
    recurringPaymentFeeOffOn:
      values?.[Fields.GENERAL_PAL_RECURRING_FEE_OFF_ON.name],
    singlePaymentFeeOffOn:
      values?.[Fields.GENERAL_PAL_SINGLE_PAYMENT_FEE_OFF_ON.name],
    debitCardOffOn: values?.[Fields.GENERAL_DEBIT_CARD_OFF_ON.name],
    externalDdaOffOn: values?.[Fields.GENERAL_EXTERNAL_DDA_OFF_ON.name],
    updatedAtDerived: values?.lastUpdatedAt,
  };
};

export const getValuesForExtDdaRtConfigApi = (values) => {
  const featureEnabled = values?.extDdaRtConfig?.featureEnabled;
  const delayDays = values?.extDdaRtConfig?.delayDays;
  return { extDdaRtConfig: buildExtDdaRtConfig(featureEnabled, delayDays) };
};

const Triple = {
  principalOffOn: OFF,
  interestOffOn: OFF,
  escrowOffOn: OFF,
};
const Double = { principalOffOn: OFF, interestOffOn: OFF };

/**
 * Canonical "blank" template for `paymentPurposeConfig`.
 * Matches the **exact** JSON structure returned by the PAL API, but with every
 * leaf initialized to 'off'.
 */
export const PaymentPurposeTemplate = {
  mortgagePaymentTypes: { ...Triple },
  helocPaymentTypes: { ...Triple },
  studentPaymentTypes: { ...Double },
  personalPaymentTypes: { ...Double },
  autoPaymentTypes: { ...Double },
  otherPaymentTypes: { ...Double },
  creditCardPaymentTypes: { ...Double },
};

/**
 * Coerces all nested paymentPurposeConfig fields to ensure they are either 'on' or 'off'.
 * Sanitizes empty strings, undefined, null, or any other invalid values by converting to 'off'.
 * This prevents blank or invalid values from being sent to the API.
 *
 * @param {Object} paymentPurposeConfig - The config object with nested fields
 * @returns {Object} Coerced config object with all leaf values as 'on' or 'off'
 */
export const coercePaymentPurposeConfig = (paymentPurposeConfig) => {
  if (!paymentPurposeConfig) {
    // Return a deep clone to prevent mutations from affecting the exported template
    return {
      mortgagePaymentTypes: { ...PaymentPurposeTemplate.mortgagePaymentTypes },
      helocPaymentTypes: { ...PaymentPurposeTemplate.helocPaymentTypes },
      studentPaymentTypes: { ...PaymentPurposeTemplate.studentPaymentTypes },
      personalPaymentTypes: { ...PaymentPurposeTemplate.personalPaymentTypes },
      autoPaymentTypes: { ...PaymentPurposeTemplate.autoPaymentTypes },
      otherPaymentTypes: { ...PaymentPurposeTemplate.otherPaymentTypes },
      creditCardPaymentTypes: {
        ...PaymentPurposeTemplate.creditCardPaymentTypes,
      },
    };
  }

  const coerceValue = (value) => (value === ON ? ON : OFF);

  return {
    mortgagePaymentTypes: {
      principalOffOn: coerceValue(
        paymentPurposeConfig?.mortgagePaymentTypes?.principalOffOn
      ),
      interestOffOn: coerceValue(
        paymentPurposeConfig?.mortgagePaymentTypes?.interestOffOn
      ),
      escrowOffOn: coerceValue(
        paymentPurposeConfig?.mortgagePaymentTypes?.escrowOffOn
      ),
    },
    helocPaymentTypes: {
      principalOffOn: coerceValue(
        paymentPurposeConfig?.helocPaymentTypes?.principalOffOn
      ),
      interestOffOn: coerceValue(
        paymentPurposeConfig?.helocPaymentTypes?.interestOffOn
      ),
      escrowOffOn: coerceValue(
        paymentPurposeConfig?.helocPaymentTypes?.escrowOffOn
      ),
    },
    studentPaymentTypes: {
      principalOffOn: coerceValue(
        paymentPurposeConfig?.studentPaymentTypes?.principalOffOn
      ),
      interestOffOn: coerceValue(
        paymentPurposeConfig?.studentPaymentTypes?.interestOffOn
      ),
    },
    personalPaymentTypes: {
      principalOffOn: coerceValue(
        paymentPurposeConfig?.personalPaymentTypes?.principalOffOn
      ),
      interestOffOn: coerceValue(
        paymentPurposeConfig?.personalPaymentTypes?.interestOffOn
      ),
    },
    autoPaymentTypes: {
      principalOffOn: coerceValue(
        paymentPurposeConfig?.autoPaymentTypes?.principalOffOn
      ),
      interestOffOn: coerceValue(
        paymentPurposeConfig?.autoPaymentTypes?.interestOffOn
      ),
    },
    otherPaymentTypes: {
      principalOffOn: coerceValue(
        paymentPurposeConfig?.otherPaymentTypes?.principalOffOn
      ),
      interestOffOn: coerceValue(
        paymentPurposeConfig?.otherPaymentTypes?.interestOffOn
      ),
    },
    creditCardPaymentTypes: {
      principalOffOn: coerceValue(
        paymentPurposeConfig?.creditCardPaymentTypes?.principalOffOn
      ),
      interestOffOn: coerceValue(
        paymentPurposeConfig?.creditCardPaymentTypes?.interestOffOn
      ),
    },
  };
};
